@import "../../../globalStyles/commons";

:host {
  display: block;
}

.tree-view {
  background-color: var(--layer);
}
